var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0005 0H2.00049C0.900488 0 0.000488281 0.9 0.000488281 2V18C0.000488281 19.1 0.900488 20 2.00049 20H18.0005C19.1005 20 20.0005 19.1 20.0005 18V2C20.0005 0.9 19.1005 0 18.0005 0ZM6.00049 17H3.00049V8H6.00049V17ZM4.50049 6.3C3.50049 6.3 2.70049 5.5 2.70049 4.5C2.70049 3.5 3.50049 2.7 4.50049 2.7C5.50049 2.7 6.30049 3.5 6.30049 4.5C6.30049 5.5 5.50049 6.3 4.50049 6.3ZM17.0005 17H14.0005V11.7C14.0005 10.9 13.3005 10.2 12.5005 10.2C11.7005 10.2 11.0005 10.9 11.0005 11.7V17H8.00049V8H11.0005V9.2C11.5005 8.4 12.6005 7.8 13.5005 7.8C15.4005 7.8 17.0005 9.4 17.0005 11.3V17Z",
    fill: "#1D1D1B"
  })));
};
export default SvgLinkedin;